// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.division[data-v-57cdde30] {\n  display: inline-block;\n  width: 18px;\n  margin-left: calc(40%);\n  padding: 1px 0;\n  cursor: ns-resize;\n}\n.division .line[data-v-57cdde30] {\n  width: 100%;\n  height: 0px;\n  margin-bottom: 1px;\n  border-bottom: 2px solid #bdbdbd;\n}\n", ""]);
// Exports
module.exports = exports;
